module.exports = __webpack_public_path__ + "static/media/zhizao11.c1ebfe08.png";